import { DependencyList, useEffect, RefObject } from 'react';

const useRecalculateTableWidth = (
  tableContainerRef: RefObject<HTMLDivElement | null>,
  dependencies: DependencyList,
) => {
  useEffect(() => {
    const recalculateTableWidth = () => {
      if (tableContainerRef.current) {
        tableContainerRef.current.style.width = '100%';
      }
    };

    recalculateTableWidth();
  }, dependencies);
};

export default useRecalculateTableWidth;
